import { createFileRoute } from '@tanstack/react-router';
import { AdminSanctionsQueuePage } from '../../features/verification';

export const Route = createFileRoute('/admin/sanctions')({ component: AdminSanctionsQueuePage });
